import React, { useRef, useEffect } from "react";
import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  apiKey: "AIzaSyA_JZymOy6M3IfEwlhmyx3qGhw70qpjoWM",
  version: "weekly",
});

async function initMap(mapRef) {

  const values = await Promise.all([loader.importLibrary("maps"), loader.importLibrary("marker")]);
  const { Map } = values[0];
  const { Marker } = values[1]

  // The location of SlonecznePodgorze
  const position = { lat: 50.378937942575746, lng: 16.376592961274678 };

  // The map, centered at SlonecznePodgorze
  const map = new Map(mapRef.current, {
    zoom: 17,
    center: position,
    mapId: "some-id",
    mapTypeId: "hybrid",
  });

  // The marker, positioned at SlonecznePodgorze
  new Marker({
    map: map,
    position: position,
    title: "Słoneczne Podgórze",
  });
}

export default function GoogleMap({ style }) {

  const mapRef = useRef(null);

  useEffect(() => {
        initMap(mapRef);
  }, []);

  return <div ref={mapRef} style={style}></div>;
};
